import { axios } from "@cores/axiosWrapper";

export const getMetricsTenantsAPI = async (apiEndpoint, params) => {
    return axios.get(`${apiEndpoint}/tenants`, { params });
};

export const getMetricsProjectsAPI = async (apiEndpoint, params) => {
    return axios.get(`${apiEndpoint}/metric-data/projects`, { params });
};

export const getMetricsMetricsAPI = async (apiEndpoint, params) => {
    return axios.get(`${apiEndpoint}/metrics`, { params });
};

export const getMetricsMetricDataAPI = async (apiEndpoint, metricId, params) => {
    return axios.get(`${apiEndpoint}/metrics/${metricId}/data`, { params });
};
